import axios from "axios"
import tokenService from "../services/TokenService"
import {logout} from "../store/actions/authActions"
import {setupStore} from "../store"

const store = setupStore()

const $api = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_BACKEND_ENDPOINT
})

$api.interceptors.request.use(config => {
  const {token} = tokenService
  config.headers.Authorization = `Bearer ${token}`
  return config
})

$api.interceptors.response.use(
  (config) => {
    return config
  },
  async (error) => {

    if (error.response.status === 401) {
      await store.dispatch(logout())
    }

    return Promise.reject(error)
  }
)


export default $api